module.exports = __webpack_public_path__ + "img/conbrie-logo.e8504e96.png";